'use client';

import Link from 'next/link';

export default function GlobalError({ reset }: { reset: () => void }) {
  return (
    <html lang="en">
      <body style={{ fontFamily: 'sans-serif', textAlign: 'center', padding: '4rem', background: '#FAFAF9' }}>
        <h1 style={{ fontSize: '2rem', color: '#1E293B', marginBottom: '1rem' }}>Something went wrong</h1>
        <p style={{ color: '#64748b', marginBottom: '2rem' }}>An unexpected error occurred. Please try again.</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <button
            onClick={reset}
            style={{ background: '#f97316', color: '#fff', border: 'none', borderRadius: '0.75rem', padding: '0.75rem 1.5rem', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' }}
          >
            Try again
          </button>
          <Link
            href="/"
            style={{ background: '#1e293b', color: '#fff', borderRadius: '0.75rem', padding: '0.75rem 1.5rem', fontWeight: 600, textDecoration: 'none', fontSize: '0.9rem' }}
          >
            Go home
          </Link>
        </div>
      </body>
    </html>
  );
}
